export default __webpack_public_path__ + "static/media/2.789ab3b7.png";